/* eslint-disable no-nested-ternary */
import {view} from '@sail/ui';
import {
  InlineDatumReactComponentProps,
  useAnalytics,
} from '@stripe-internal/inline-data';
import {LightCard} from '@stripe-internal/conversations-ui';

import {CurrentMerchantSection} from '../helpers/CurrentMerchantSection';
import {VerificationIssueSection} from './VerificationIssueSection';

export type VerificationIssueTime = 'blocked_now' | 'blocked_soon';
export type ValueProps = {
  verification_issue_time?: VerificationIssueTime;
  has_verification_issue?: boolean;
  merchant_name?: string;
  merchant_avatar?: string;
  universal_help_new_design?: boolean;
};

export const MerchantVerificationAffectingPayouts = (
  props: InlineDatumReactComponentProps,
) => {
  const {datum} = props;
  const value = datum.value as ValueProps;

  const {
    verification_issue_time: verificationIssueTime,
    merchant_name: merchantName,
    merchant_avatar: merchantAvatar,
    universal_help_new_design: universalHelpNewDesign,
  } = value;

  const analytics = useAnalytics();

  analytics.viewed('uh_merchant_verification_affecting_payouts');

  return (
    <LightCard isOuter>
      <view.div
        css={{stack: 'y', gap: 'medium'}}
        data-testid="merchant-verification-affecting-payouts"
      >
        {!universalHelpNewDesign && merchantName ? (
          <CurrentMerchantSection
            merchantName={merchantName}
            merchantAvatar={merchantAvatar}
          />
        ) : null}
        <VerificationIssueSection
          verificationIssueTime={verificationIssueTime}
        />
      </view.div>
    </LightCard>
  );
};
